export default __webpack_public_path__ + "static/media/placeholder.3f58a5d1.png";